import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import I18n from 'i18n-js'
import { makeStyles } from 'tss-react/mui'

import cloudinary from '@src/lib/Cloudinary'

import { campaignTotals } from './statsTotals'

const useStyles = makeStyles()((theme) => {
  return {
    imageContainer: {
      height: '147px',
      overflow: 'hidden',
      width: '220px',
      display: 'flex',
      alignItems: 'center',
    },
    statsContainer: {
      borderRadius: theme.shape.borderRadius,
      padding: `${theme.spacing(2)} ${theme.spacing(6)}`,
      display: 'flex',
      flexDirection: 'row',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'row',
        width: 'calc(100vw - 4em)',
      },
    },
    statsBox: {
      margin: theme.spacing(2),
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        width: '100%',
      },
    },
    stat: {
      minWidth: '80px',
      textAlign: 'center',
      fontSize: '36px',
      fontWeight: theme.typography.fontWeightBold,
      [theme.breakpoints.down('sm')]: {
        minWidth: '0px',
      },
    },
  }
})

const OrganicCampaignDetailsHeader = ({ campaign, stats }) => {
  const { classes } = useStyles()
  const { totals } = campaignTotals(stats)
  const campaignLogoUrl = campaign.logo_public_id
    ? cloudinary.instance().url(`${campaign.logo_public_id}.jpg`, {
        width: 220,
        height: 147,
        crop: 'fill',
        format: 'jpg',
        quality: 'auto',
      })
    : campaign.logo_url

  return (
    <Grid alignItems="center" container>
      <Grid item sm={8} xs={12}>
        <Box display="flex" wrap="nowrap">
          <div className={classes.imageContainer}>
            <img
              alt={campaign.name}
              src={campaignLogoUrl}
              style={{
                objectFit: 'contain',
              }}
              width="100%"
            />
          </div>

          <Box
            alignItems="flex-start"
            display="flex"
            flexDirection="column"
            justifyContent="center"
            margin="0 16px"
          >
            <Box padding="8px 0px">
              <Typography variant="h5">{campaign.name}</Typography>
            </Box>
            <Box alignItems="center" display="flex" justifyContent="flex-start">
              <Box
                component="img"
                height="32px"
                maxWidth="140px"
                padding="8px 0px"
                src={campaign.brand.logo_url}
                style={{
                  objectFit: 'contain',
                }}
              />
              <Box padding="0px 8px">{campaign.brand.name}</Box>
            </Box>
          </Box>
        </Box>
      </Grid>
      <Grid item sm={4} xs={12}>
        <Box display="flex" justifyContent="flex-end">
          <Box boxShadow={4} className={classes.statsContainer}>
            <Stats
              count={I18n.l('number', totals.views)}
              label={I18n.t('reporting.totalViews')}
            />
            <Stats
              count={I18n.l('number', totals.actions)}
              label={I18n.t('reporting.totalActions')}
            />
            <Stats
              count={I18n.l('number', totals.clicks)}
              label={I18n.t('reporting.totalLinkClicks')}
            />
          </Box>
        </Box>
      </Grid>
    </Grid>
  )
}

function Stats({ count = 0, label }) {
  const { classes } = useStyles()
  return (
    <Box className={classes.statsBox}>
      <Box className={classes.stat} component={Typography} variant="h6">
        {count}
      </Box>
      <Box fontSize="18px">{label}</Box>
    </Box>
  )
}

export default OrganicCampaignDetailsHeader
